<template>
	<div class="wrapper-content animated fadeInRight tabBox" id="dictionary-list">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">字典类型</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="queryParam.udcTypes">
					</div>
					<label class="col-sm-1 control-label">字典名称</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="queryParam.name">
					</div>
						<label class="col-sm-1 control-label">CODE</label>
					<div class="col-sm-3">
						<input type="text" class="form-control" v-model.trim="queryParam.code">
					</div>
				</div>
				<div class="form-group">
				    <div class="col-sm-12 text-right">
				    	<button type="button" v-if="permission.indexOf('alarmPlanList_select') == -1" @click="searchInfo" class="btn btn-primary">查询</button>
				    	<button type="button" v-if="permission.indexOf('alarmPlanList_reset') == -1" @click="resetQueryParams" class="btn btn-primary">重置</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
					 <div class="col-sm-12 text-right">
				    	<button	type="button" class="btn btn-primary" @click="openEdit('new')">新建</button>
					</div>
				</div>
			</div>
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr role="row">
							<th v-for="(thead, index) in theadList" :key="'dictinonary' + index">{{thead}}</th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(udcInfo,index) in udcList" v-bind:key="index + 'dictinonarylist'" class="list-complete-item text-overflow">
							<td>{{udcInfo.udcTypes}}</td>
							<td class="td-maxWidth">{{udcInfo.udcName}}</td>
							<td class="td-maxWidth">{{udcInfo.udcCode}}</td>
							<td class="text-center">
								<a  @click="openEdit('detail',index)">详情&nbsp;</a>
								<a class="mt-3" @click="openEdit('edit',index)">&nbsp;编辑</a>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			<!--表格结束-->
			<Pagination v-if="udcList.length>0" :pageInfo="pageInfo" v-on:getData="getParam"></Pagination>
		</div>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<!--   弹出框子组件2        -->
		<tab-modal ref="modal2" size="small" title="提示" :scroll='scrollTop'  v-on:cancel="closeModal('modal2')">
			确定删除 {{udcList[listIndex]?udcList[listIndex].udcname:''}} 字典？
			<div slot="footer">
		            <button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
		            <button @click="removePlanItem()" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<sub-page
			:show="toShow"
				:bigTitleMsg="bigTitle"
				v-on:cancel="closeSubPage"
				:scroll="scrollTop">
				<div slot="bodycontent">
					<page-dictionary-edit
						v-on:cancel="closeSubPage"
						:dataInfo="editUdc"
						:isRead="toRead"
						:editType="typeEnable"
						>
					</page-dictionary-edit>
				</div>

		</sub-page>
	</div>
</template>

<script>
	import Pagination from 'components/common/Pagination'
	import TabModal from 'components/common/TabModal'
	import { OPERATE_EXCEPTION } from 'static/message'
	import classlist from 'util/classlist'
	import PageDictionaryEdit from 'components/pages/dictionary/PageDictionaryEdit'
	import SubPage from 'components/common/SubPage'
	export default {
	  name: 'PageDictionaryList',
	  components: {
	    SubPage,
	    Pagination,
	    TabModal,
	    PageDictionaryEdit
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['dictionaryList'] ? this.$store.state.permission.permission['dictionaryList'] : [],
	      loadingstatus: false,
	      udcList: [],
	      toShow: false,
	      editUdc: {},
	      bigTitle: '',
	      toRead: true,
	      pageInfo: {},
	      listIndex: 0,				                            // 列表索引
	      queryParam: {
	        code: '',
	        name: '',											// 名称
	        page_index: 1,										// 当前第几页
	        udcTypes: ''											// 类型
	      },
	      theadList: [ '字典类型', '名称', 'CODE', ''],
	      messageStr: '',			                        // 弹出框内容
	      scrollTop: '0',
	      typeEnable: true
	    }
	  },
	  beforeMount () {
			// 初始化信息
	    this.getTableInfo()
	  },
	  methods: {

			// 查询方法
	    searchInfo () {
	      this.queryParam.page_index = 1
	      this.getTableInfo()
	    },
			// 初始化
	    getTableInfo: function () {
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/system/udcs/page', {params: this.queryParam})
					.then((response) => {
	  if (response.body.success) {
	    if (response.body.data) {
	      const res = response.body.data
	      this.udcList = res.list
	      const {pageNum, pages, total, isFirstPage, isLastPage} = res
	      this.pageInfo = {
	        pageNum: pageNum,
	        pages: pages,
	        total: total,
	        isFirstPage: isFirstPage,
	        isLastPage: isLastPage
	      }
	    }
	  } else {
					       this.openModalMsg(response.body.message)
	  }
	  this.loadingstatus = false
	}, (response) => {
					   this.openModalMsg(response.body.message)
				   this.loadingstatus = false
	})
					.catch((response) => {
				        this.openModalMsg(OPERATE_EXCEPTION)
			        this.loadingstatus = false
	})
	    },
			// 重置信息
	    resetQueryParams: function () {
	      this.queryParam = {
	        code: '',
	        name: '',											// 名称
	        page_index: 1,										// 当前第几页
	        udcTypes: ''											// 类型
	      }
	    },
			// 从分页组件获取页码参数
	    getParam: function (param) {
	      this.queryParam.page_index = param
	      this.getTableInfo()
	    },
			// 消息弹出框相关
	    openModal (ref) {
            	this.$refs[ref].open()
            	classlist.toggleScroll('close', '#dictionary-list', this)
        	},
        	closeModal (ref) {
        		this.$refs[ref].close()
        		classlist.toggleScroll('open', '#dictionary-list', this)
        	},
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        	},
        	openModalMsg (message) {
        		this.messageStr = message
        		this.openModal('modalMsg')
        	},
        	openEdit (keywords, index) { // 点击打开弹框（新建、编辑、详情组件）
	          if (keywords === 'new') {
	            this.toRead = false
	            this.bigTitle = '新建字典表'
	            this.editUdc = ''
	            this.typeEnable = true
	            this.toShow = true
	          } else {
	            if (keywords === 'detail') {
						// 查看详情
	              this.toRead = true
	              this.bigTitle = '查看字典'
	              this.editInit(index)
	              this.typeEnable = false
	            } else if (keywords === 'edit') {
	              this.bigTitle = '编辑字典'
	              this.toRead = false
						// 编辑初始化
	              this.editInit(index)
	              this.typeEnable = false
	            } else {
	              return false
	            }
	          }
	          classlist.toggleScroll('close', '#dictionary-list', this)
	        },
	    closeSubPage () {
	      this.toShow = false
	      classlist.toggleScroll('open', '#dictionary-list', this)
	    },
	    editInit (index) {
	      this.editUdc = this.udcList[index].udcTypes
	      this.toShow = true
	    }
	  }
	}

</script>
<style scoped>
	.mt-3{
		margin-right:10px;
	}
	.td-maxWidth{
		max-width:200px;
		word-wrap:break-word;
	}
</style>



// WEBPACK FOOTER //
// PageDictionaryList.vue?062b7edf